import type { FileState } from "@repo/types"
import { create } from "zustand"

export const useFile = create<FileState>((set) => ({
  clear: () => set({ base64: null, name: null }),
  set: (n) => set((x) => ({ ...x, ...n })),
  base64: null,
  name: null
}))
